// extracted by mini-css-extract-plugin
module.exports =  {"root":"Q7TpaJQG59kZt3Ps0ttC"};